import { render, staticRenderFns } from "./SimilarArtistCard.vue?vue&type=template&id=5291ef54&scoped=true&"
import script from "./SimilarArtistCard.vue?vue&type=script&lang=js&"
export * from "./SimilarArtistCard.vue?vue&type=script&lang=js&"
import style0 from "./SimilarArtistCard.vue?vue&type=style&index=0&id=5291ef54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5291ef54",
  null
  
)

export default component.exports